import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ListItem } from '@/viewmodel/features/analysisSpec/types';

type GoldCreationState = {
  messages: ListItem[];
  instructions: ListItem[];
};

const initialState: GoldCreationState = {
  messages: [],
  instructions: [],
};

const goldCreationSlice = createSlice({
  name: 'goldCreation',
  initialState,
  reducers: {
    addInstruction: (state, action: PayloadAction<string>) => {
      state.instructions.push({ id: crypto.randomUUID(), text: action.payload });
    },
    removeInstruction: (state, action: PayloadAction<string>) => {
      state.instructions = state.instructions.filter((i) => i.id !== action.payload);
    },
    resetGoldCreation: () => initialState,
  },
});

export const { addInstruction, removeInstruction, resetGoldCreation } = goldCreationSlice.actions;
export default goldCreationSlice.reducer;

type GoldCreationRootState = { goldCreation: GoldCreationState };

export const selectGoldCreationMessages = (state: GoldCreationRootState) =>
  state.goldCreation.messages;
export const selectGoldCreationInstructions = (state: GoldCreationRootState) =>
  state.goldCreation.instructions;
